<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-ticket mr-2" />Invoice</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="No. Faktur">
                        <b-form-input v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status">
                        <b-form-select v-model="filter.status" :options="optFilterStatus" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3">
                    <b-form-group label="Tgl. Pengembalian Dari">
                        <b-form-input type="date" v-model="filter.startDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Tgl. Pengembalian Sampai">
                        <b-form-input type="date" v-model="filter.endDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" class="ml-2" @click="$bvModal.show('m-create')">
                            <i class="fa fa-plus mr-2" />Invoice Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data invoice.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    {{ row.item.no_faktur || "--DRAFT--" }}
                    <div class="small text-muted">
                        {{ row.item.no_ref || "-" }}
                    </div>
                </template>
                <template v-slot:cell(return_at)="row">
                    {{ $helper.parseDate(row.item.return_at) }}
                    <div class="small text-muted">
                        {{ row.item.created_by }} - {{ $helper.parseDate(row.item.created) }}, {{ $helper.parseHourMinute(row.item.created) }}
                    </div>
                    <div class="small">
                        {{ row.item.inventory_returns_count }} unit barang - {{ row.item.division }}
                    </div>
                </template>
                <template v-slot:cell(returnTo)="row">
                    Ke : {{ row.item.return_to || "-" }}<br />
                    Dari : {{ row.item.office }}
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)[0]">{{ getStatusBadge(row.item.status)[1] }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <router-link v-if="row.item.status == 1" :to="'invoice/draft/' + row.item.id">
                        <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Lanjut Draft">
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                    </router-link>
                    <router-link v-if="row.item.status == 2" :to="'invoice/' + row.item.id">
                        <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail Invoice">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Invoice Baru" centered no-close-on-backdrop hide-footer>
            <label>Konfirmasi pembuatan Invoice Pengembalian PGI</label>
            <b-form-group label="Untuk office...">
                <multiselect v-model="input.office"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optOffices"
                />
            </b-form-group>
            <b-form-group label="Untuk divisi...">
                <multiselect v-model="input.division"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optDivisions"
                />
            </b-form-group>
            <b-form-group label="Pengembalian ke...">
                <multiselect v-model="input.returnTo"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optReturnTo"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="createInvoice">
                    {{ isSubmitting ? "Membuat..." : "Buat Invoice Baru" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    components: {
    },
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                noFaktur: "",
                status: -1,
                startDate: "",
                endDate: ""
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "noFaktur", label: "No. Faktur Invoice", sortable: true },
                { key: "return_at", label: "Tgl. Pengembalian", sortable: true },
                { key: "returnTo", label: "Pengembalian", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Draft" },
                { value: 2, text: "Created" }
            ],

            optOffices: [],
            optDivisions: [],
            optReturnTo: [
                { id: "PGI", name: "PGI"},
                { id: "SGP", name: "SGP"}
            ],

            input: {
                division: null,
                returnTo: null,
                office: null
            }

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getOffices = this.$axios.get("master/offices").then(res => {
                this.optOffices = res.data.data
            })

            let getDivisions = this.$axios.get("division/get-all-filtered").then(res => {
                this.optDivisions = res.data.data
            })

            Promise.all([getItems, getDivisions, getOffices]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        createInvoice() {

            this.isSubmitting = true

            let payload = {
                division_id: this.input.division.id,
                return_to: this.input.returnTo.id,
                office_id: this.input.office.id
            }

            this.$axios.post("inventory-return-pgi/create-return-invoice", payload).then(res => {

                let data = res.data.data
                this.$router.push({ path: "invoice/draft/" + data.id })

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            if(this.sortBy != null) {
                param += "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("inventory-return-pgi/get-all-return-invoice" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listInvoiceKirimBalikFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getStatusBadge(status) {
            switch(status) {
                case 1: return ["dark", "DRAFT"]
                case 2: return ["success", "CREATED"]
                default: return ["light", "-"]
            }
        }

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listInvoiceKirimBalikFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listInvoiceKirimBalikFilter"))
        }
        this.init()
        this.$helper.toastFlash(this)
    }
}
</script>
